module.exports = __webpack_public_path__ + "img/choiceLogo.db7f8f48.png";